import React, { useState } from 'react'
import { Modal, message } from 'antd';
import { url } from "../Constent/Constant";
import { DropzoneArea } from 'material-ui-dropzone';

const Achievement = ({ CardSection, UpdateImage, UpdateText }) => {
    const [TextUpdate, setTextUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [ImageModal, setImageModal] = useState(false);
    const [TextId, setTextId] = useState('')
    const [ImageId, setImageId] = useState('')
    const [HeadingUpdate, setHeadingUpdate] = useState('')

    const showImageModal = (id) => {
        setImageModal(true);
        setImageId(id)
    };

    const showTextModal = (id) => {
        setTextModalVisible(true);
        setTextId(id)
    };

    const TextHandle = () => { if (TextUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: TextUpdate,
                id: 
                
                
                TextId
            })
            setTextModalVisible(false);
            setTextUpdate('')
        }
    };

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: ImageId
            })
            setImageModal(false);
        }
    };

    const handleCancel = () => {
        setTextModalVisible(false);
        setImageModal(false);
    };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if(event.key === 'Enter'){
          console.log('Enter Clicked')
          a.concat('\n')
          setHeadingUpdate(a)
        }else{
          console.log(event.key)
        }
      }

    return (
        <div className='Achievement-Container'>
            <div className='Achievement-left-box'>
                <img src={`${url}/api/getFile${CardSection.image}`} alt='Achievement' draggable='false' />
                <i onClick={() => showImageModal(CardSection.imageId)} className="far fa-edit Edit-btn"></i>
            </div>
            <div className='Achievement-right-box'>
                <h2>{CardSection ? CardSection.heading : ''}
                    <i onClick={() => showTextModal(CardSection.headingId)} className="far fa-edit Edit-btn"></i>
                </h2>
                <div className='Achievement-list'>
                    <p> {CardSection ? CardSection.para : ''}
                        <i onClick={() => showTextModal(CardSection.paraId)} className="far fa-edit Edit-btn"></i>
                    </p>
                </div>
            </div>

            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e)=> OnEnterPress(e)} value={TextUpdate} onChange={e => setTextUpdate(e.target.value)} className='Input' placeholder='Update Text...' />
            </Modal>

            {/* Update Image Modal */}
            <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>
        </div>
    )
}

export default Achievement
